import React from "react";
import { BsLinkedin } from "react-icons/bs";
import { AiFillGithub } from "react-icons/ai";
import "./Socalmedia.css";

function Socalmedia() {
  return (
    <div className="core-social-media">
      <a
        href="https://www.linkedin.com/in/shihab-ahmed-57b161152/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <BsLinkedin className="linkedin-icon" />
      </a>
      <a
        href="https://github.com/shihab-sa"
        target="_blank"
        rel="noopener noreferrer"
      >
        <AiFillGithub className="github-icon" />
      </a>
    </div>
  );
}

export default Socalmedia;
